import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useTourismData } from '../../context/TourismContext'
import { getImageUrl } from '../../services/api'

function AboutTwo() {
    // Get tourism data and actions from context
    const { airTicket, fetchAirTicketAboutSection } = useTourismData();
    const { aboutSection } = airTicket;

    useEffect(() => {
        const fetchData = async () => {
            try {
                await fetchAirTicketAboutSection();
            } catch (error) {
                console.error('Error fetching AirTicket about section:', error);
            }
        };
        
        fetchData();
    }, [fetchAirTicketAboutSection]);

    // Fallback data if API data is not available
    const fallbackData = {
        subtitle: "Let's Go Together",
        title: "Plan Your Trip With us",
        description: "There are many variations of passages of available but the majority have suffered alteration in some form, by injected hum randomised words.",
        feature1_title: "Exclusive Trip",
        feature1_description: "There are many variations of passages of available but the majority.",
        feature2_title: "Safety First Always",
        feature2_description: "There are many variations of passages of available but the majority.",
        feature3_title: "Professional Guide",
        feature3_description: "There are many variations of passages of available but the majority.",
        button_text: "Learn More",
        button_link: "/about"
    };

    // Use API data if available, otherwise use fallback
    const displayData = aboutSection || fallbackData;
    return (
        <div
            className="about-area position-relative overflow-hidden space"
            id="about-sec"
        >
            <div className="container shape-mockup-wrap">
                <div className="row">
                    <div className="col-xl-7">
                        <div className="img-box3">
                            <div className="img1">
                                <img 
                                    src={getImageUrl(displayData.image1_url) || "/assets/img/normal/about_3_1.jpg"} 
                                    alt="About our services" 
                                    onError={(e) => {
                                        e.target.src = "/assets/img/normal/about_3_1.jpg";
                                    }}
                                />
                            </div>
                            <div className="img2">
                                <img 
                                    src={getImageUrl(displayData.image2_url) || "/assets/img/normal/about_3_2.jpg"} 
                                    alt="Travel experience" 
                                    onError={(e) => {
                                        e.target.src = "/assets/img/normal/about_3_2.jpg";
                                    }}
                                />
                            </div>
                            <div className="img3 movingX">
                                <img 
                                    src={getImageUrl(displayData.image3_url) || "/assets/img/normal/about_3_3.jpg"} 
                                    alt="Flight booking experience" 
                                    onError={(e) => {
                                        e.target.src = "/assets/img/normal/about_3_3.jpg";
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-5">
                        <div className="ps-xl-4">
                            <div className="title-area mb-20 pe-xxl-5 me-xxl-5">
                                <span className="sub-title style1">
                                    {displayData.subtitle || "Let's Go Together"}
                                </span>
                                <h2 className="sec-title mb-20 pe-xl-5 me-xl-5 heading">
                                    {displayData.title || "Plan Your Trip With us"}
                                </h2>
                            </div>
                            <p className="sec-text mb-30">
                                {displayData.description || "There are many variations of passages of available but the majority have suffered alteration in some form, by injected hum randomised words."}
                            </p>
                            <div className="about-item-wrap">
                                <div className="about-item style2">
                                    <div className="about-item_img">
                                        <i className={displayData.feature1_icon || "fas fa-plane"} style={{ fontSize: '24px', color: '#0066cc' }}></i>
                                    </div>
                                    <div className="about-item_centent">
                                        <h5 className="box-title">
                                            {displayData.feature1_title || "Exclusive Trip"}
                                        </h5>
                                        <p className="about-item_text">
                                            {displayData.feature1_description || "There are many variations of passages of available but the majority."}
                                        </p>
                                    </div>
                                </div>
                                <div className="about-item style2">
                                    <div className="about-item_img">
                                        <i className={displayData.feature2_icon || "fas fa-shield-alt"} style={{ fontSize: '24px', color: '#0066cc' }}></i>
                                    </div>
                                    <div className="about-item_centent">
                                        <h5 className="box-title">
                                            {displayData.feature2_title || "Safety First Always"}
                                        </h5>
                                        <p className="about-item_text">
                                            {displayData.feature2_description || "There are many variations of passages of available but the majority."}
                                        </p>
                                    </div>
                                </div>
                                <div className="about-item style2">
                                    <div className="about-item_img">
                                        <i className={displayData.feature3_icon || "fas fa-clock"} style={{ fontSize: '24px', color: '#0066cc' }}></i>
                                    </div>
                                    <div className="about-item_centent">
                                        <h5 className="box-title">
                                            {displayData.feature3_title || "Professional Guide"}
                                        </h5>
                                        <p className="about-item_text">
                                            {displayData.feature3_description || "There are many variations of passages of available but the majority."}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-35">
                                <Link 
                                    to={displayData.button_link || "/about"} 
                                    className="th-btn style3 th-icon"
                                >
                                    {displayData.button_text || "Learn More"}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="shape-mockup movingX d-none d-xxl-block"
                    style={{
                        top: "0%",
                        left: "-20%",
                    }}
                >
                    <img src="/assets/img/shape/shape_2_1.png" alt="shape" />
                </div>
                <div
                    className="shape-mockup jump d-none d-xxl-block"
                    style={{
                        top: "20%",
                        right: "-15%",
                    }}
                >
                    <img src="/assets/img/shape/shape_2_2.png" alt="shape" />
                </div>
                <div
                    className="shape-mockup spin d-none d-xxl-block"
                    style={{
                        bottom: "18%",
                        left: "-17%",
                    }}
                >
                    <img src="/assets/img/shape/shape_2_3.png" alt="shape" />
                </div>
                <div
                    className="shape-mockup movixgX d-none d-xxl-block"
                    style={{
                        bottom: "10%",
                        right: "-18%",
                    }}
                >
                    <img src="/assets/img/shape/shape_2_4.png" alt="shape" />
                </div>
            </div>
            <div
                className="shape-mockup movingCar d-none d-xxl-block"
                style={{
                    bottom: "0%",
                    right: "-2%",
                }}
            >
                <img src="/assets/img/shape/car_1.png" alt="shape" />
            </div>
            <div
                className="shape-mockup d-none d-xxl-block"
                style={{
                    bottom: "0%",
                    right: "0%",
                }}
            >
                <img src="/assets/img/shape/tree_1.png" alt="shape" />
            </div>
        </div>

    )
}

export default AboutTwo
